import classNames from 'classnames';

import Anchor from '~components/Anchor/Anchor';
import ArrowIcon from '~images/inline/arrow-thin-left.inline.svg';

type Props = {
    showbackbutton: boolean;
    shownextbutton: boolean;
    backlink: string;
    backtext: string;
    nextlink: string;
    nexttext: string;
    nextwalink: string;
    backwalink: string;
};

const NextBackButton = ({
    showbackbutton,
    shownextbutton,
    backlink,
    backtext,
    nextlink,
    nexttext,
    nextwalink,
    backwalink,
}: Props) => {
    return (
        <div
            className={`w-full my-4 flex mx-auto items-center ${
                showbackbutton ? 'justify-between' : 'justify-end'
            }`}
        >
            {showbackbutton && (
                <Anchor
                    to={backlink}
                    className="hidden lg:flex items-center text-24"
                    data-wa-link={backwalink}
                >
                    <ArrowIcon className="text-primary" />
                    <span className="ml-2 text-link">{backtext}</span>
                </Anchor>
            )}
            {shownextbutton && (
                <Anchor
                    to={nextlink}
                    className={classNames(
                        'flex justify-between items-center',
                        'p-3 text-white rounded-full font-bold text-24',
                        'bg-interactive-action hover:bg-interactive-action-hover',
                        'focus:outline focus:outline-4 focus:outline-interactive-action-hover'
                    )}
                    data-wa-link={nextwalink}
                >
                    <span className="font-bold">Next:&nbsp;</span>
                    {nexttext}
                    <ArrowIcon className="rotate-180 ml-1 text-white" />
                </Anchor>
            )}
        </div>
    );
};

export default NextBackButton;
